module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "stripe-terminal-verifone-default-splash.052082fd.png";